import Pusher from 'pusher-js';
import { getApiBaseUrl } from '../api/config';

let pusherInstance = null;
let userChannel = null;

const getAuthEndpoint = () => {
  if (process.env.REACT_APP_PUSHER_AUTH_ENDPOINT) {
    return process.env.REACT_APP_PUSHER_AUTH_ENDPOINT;
  }
  // Laravel's default broadcasting auth route lives at the API origin root,
  // not under the /api/back-offices prefix used by the REST endpoints.
  const apiBaseUrl = getApiBaseUrl() || '';
  const origin = apiBaseUrl.replace(/\/api\/.*$/, '');
  return `${origin}/broadcasting/auth`;
};

export const getPusherClient = () => {
  if (pusherInstance) return pusherInstance;

  const key = process.env.REACT_APP_PUSHER_KEY;
  const cluster = process.env.REACT_APP_PUSHER_CLUSTER;
  if (!key || !cluster) return null;

  pusherInstance = new Pusher(key, {
    cluster,
    forceTLS: process.env.REACT_APP_PUSHER_FORCE_TLS !== 'false',
    authEndpoint: getAuthEndpoint(),
    auth: {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
        Accept: 'application/json',
      },
    },
  });

  return pusherInstance;
};

/**
 * Subscribes to the current user's private notification channel and binds
 * the broadcast-notification event. Returns an unsubscribe function.
 */
export const subscribeToUserNotifications = (userId, onNotification) => {
  if (!userId) return () => {};

  const client = getPusherClient();
  if (!client) return () => {};

  const channelTemplate = process.env.REACT_APP_PUSHER_USER_CHANNEL || 'private-App.Models.User.{id}';
  const channelName = channelTemplate.replace('{id}', userId);
  const eventName = process.env.REACT_APP_PUSHER_NOTIFICATION_EVENTS
    || 'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated';

  userChannel = client.subscribe(channelName);
  userChannel.bind(eventName, onNotification);

  return () => {
    if (!userChannel) return;
    userChannel.unbind(eventName, onNotification);
    client.unsubscribe(channelName);
    userChannel = null;
  };
};

export const disconnectPusher = () => {
  if (pusherInstance) {
    pusherInstance.disconnect();
    pusherInstance = null;
  }
};
